import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startCopyAbrArtStatus: 'idle',
    startCopyAbrArtError: undefined as any,
    loadUserParamsCopyAbrArtStatus: 'idle',
    loadUserParamsCopyAbrArtError: undefined as any,

    copyAbrArtList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startCopyAbrArt = createAsyncThunk('copyAbrArtSlice/startCopyAbrArt', async ({ copyAbrArt }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartCopyAbrArt/`,
        prepareData(copyAbrArt),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startCopyAbrArtStatus } = getState().copyAbrArtSlice
        return startCopyAbrArtStatus !== 'pending'
    }
})

export const loadUserParamsCopyAbrArt = createAsyncThunk('copyAbrArtSlice/loadUserParamsCopyAbrArt', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsCopyAbrArt/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsCopyAbrArtStatus } = getState().copyAbrArtSlice
        return loadUserParamsCopyAbrArtStatus !== 'pending'
    }
})

const CopyAbrArtSlice = createSlice({
    name: 'copyAbrArtSlice',
    initialState,
    reducers: {
        resetstartCopyAbrArt: (state) => {
            state.job = undefined
            state.startCopyAbrArtError = undefined
        },
        resetstartCopyAbrArtError: (state) => {
            state.startCopyAbrArtError = undefined
        },
        resetloadUserParamsCopyAbrArt: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsCopyAbrArtError = undefined
        },
        resetloadUserParamsCopyAbrArtError: (state) => {
            state.loadUserParamsCopyAbrArtError = undefined
        },
        removeFromCopyAbrArtListById: (state, action) => {
            state.copyAbrArtList = state.copyAbrArtList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromCopyAbrArtListByIds: (state, action) => {
            state.copyAbrArtList = state.copyAbrArtList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.copyAbrArtList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startCopyAbrArtStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.copyAbrArtList = []
            state.startCopyAbrArtStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startCopyAbrArt.pending, (state) => {
            state.startCopyAbrArtStatus = 'pending'
            state.startCopyAbrArtError = undefined
        })
        builder.addCase(startCopyAbrArt.fulfilled, (state, action) => {
            state.startCopyAbrArtStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startCopyAbrArt.rejected, (state, action) => {
            state.startCopyAbrArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startCopyAbrArtError = action.error.message
            } else {
                state.startCopyAbrArtError = action.payload
            }
        })

        builder.addCase(loadUserParamsCopyAbrArt.pending, (state) => {
            state.loadUserParamsCopyAbrArtStatus = 'pending'
            state.loadUserParamsCopyAbrArtError = undefined
        })
        builder.addCase(loadUserParamsCopyAbrArt.fulfilled, (state, action) => {
            state.loadUserParamsCopyAbrArtStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsCopyAbrArt.rejected, (state, action) => {
            state.loadUserParamsCopyAbrArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsCopyAbrArtError = action.error.message
            } else {
                state.loadUserParamsCopyAbrArtError = action.payload
            }
        })

    }
})

export const {
    resetstartCopyAbrArt,
    resetstartCopyAbrArtError,
    resetloadUserParamsCopyAbrArt,
    resetloadUserParamsCopyAbrArtError,
    removeFromCopyAbrArtListById,
    removeFromCopyAbrArtListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = CopyAbrArtSlice.actions
export default CopyAbrArtSlice.reducer
